import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock, unref as _unref } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex items-center justify-center"
}
const _hoisted_2 = {
  key: 1,
  class: "w-full"
}

import { localeDateString, shortLocaleString } from "@/helpers/datehelper";
import { Message } from "@/interfaces/message";
import { profileFromUid } from "@/helpers/requestHelpers/publicDataRequests";
import DialogCard from "@/components/DialogCard.vue";
import { ref, onMounted, watch } from "vue";
import { useOrdersStore } from "@/store/ordersStore";
import { Profile } from "@/interfaces/profile";
import ChangeTag from "@/components/ChangeTag.vue";
import ChangelogEntry from "@/components/ChangelogEntry.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";

interface ChangeRecord {
  property: string;
  from: any;
  to: any;
  by: Profile | null;
  time: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'OrderMessageHistory',
  props: {
    ofMessage: {},
    boxes: {},
    type: {}
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

const ordersStore = useOrdersStore();
const props = __props;

const emits = __emit;

const history = ref<Message[] | null>(null);

watch(
  () => props.ofMessage,
  () => {
    changelog();
  }
);

onMounted(() => {
  changelog();
  window._paq.push([
    "trackEvent",
    "Message-History",
    "Opened History",
    props.ofMessage?.type,
  ]);
});

async function changelog() {
  history.value = null;
  if (props.ofMessage == null) {
    return;
  }
  history.value = await ordersStore.loadHistory(props.ofMessage.id);
}

function findChangesOverTime(messages: Message[]): ChangeRecord[] {
  if (messages.length < 2) {
    return [];
  }

  const changeRecords: ChangeRecord[] = [];

  for (let i = 1; i < messages.length; i++) {
    const previousMsg = messages[i - 1];
    const currentMsg = messages[i];
    const by = profileFromUid(currentMsg.created_by);
    const at = shortLocaleString(currentMsg.created_at);

    const previousObject = JSON.parse(previousMsg.decrypted_message ?? "{}");
    const currentObject = JSON.parse(currentMsg.decrypted_message ?? "{}");

    Object.keys(currentObject).forEach((property) => {
      let from = undefined;
      if (property == "nincd") return;
      if (Object.prototype.hasOwnProperty.call(previousObject, property)) {
        from = previousObject[property];
      }
      if (from != currentObject[property]) {
        let to = currentObject[property];
        if (property == "date") {
          from = localeDateString(from);
          to = localeDateString(to);
        }
        changeRecords.push({
          property,
          from: from,
          to: to,
          by: by ?? null,
          time: at,
        });
      }
    });
  }

  return changeRecords;
}

function translatedProperty(property: string): string | null {
  switch (property) {
    case "box":
      return "Kiste";
    case "status":
      return "Status";
    case "note":
      return "Notiz";
    case "comment":
      return "Kommentar";
    case "patient_id":
      return "Patient";
    case "amount":
      return "Menge";
    case "gtin":
      return "GTIN";
    case "name":
      return "Produktname";
    case "date":
      return "Lieferdatum";
    case "pharmacode":
      return "Pharmacode";
    case "public_price":
      return "Preis pro Packung";
    case "storage_quantity":
      return "Lagerbestand";
    case "nincd":
      return "Liste";
    default:
      return property;
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DialogCard, {
    "show-footer": false,
    title: "Änderungsverlauf",
    "is-visible": props.ofMessage != null,
    onClose: _cache[0] || (_cache[0] = ($event: any) => (emits('close')))
  }, {
    default: _withCtx(() => [
      (history.value == null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(LoadingSpinner)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(findChangesOverTime(history.value).reverse(), (change) => {
              return (_openBlock(), _createBlock(ChangelogEntry, {
                "change-by": change.by ?? null,
                "change-text": translatedProperty(change.property) ?? '',
                "change-time": change.time,
                class: "block w-full md:flex",
                key: `${change.by}${change.time}`
              }, _createSlots({ _: 2 }, [
                (change.property != 'deleted')
                  ? {
                      name: "from",
                      fn: _withCtx(() => [
                        _createVNode(ChangeTag, {
                          property: change.property,
                          boxes: _ctx.boxes,
                          value: change.from,
                          type: props.type,
                          class: "w-full"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(change.from), 1)
                          ]),
                          _: 2
                        }, 1032, ["property", "boxes", "value", "type"])
                      ]),
                      key: "0"
                    }
                  : undefined,
                (change.property != 'deleted')
                  ? {
                      name: "to",
                      fn: _withCtx(() => [
                        _createVNode(ChangeTag, {
                          property: change.property,
                          boxes: _ctx.boxes,
                          value: change.to,
                          type: props.type,
                          class: "w-full"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(change.to), 1)
                          ]),
                          _: 2
                        }, 1032, ["property", "boxes", "value", "type"])
                      ]),
                      key: "1"
                    }
                  : undefined,
                (change.property == 'deleted' && change.to == true)
                  ? {
                      name: "custom",
                      fn: _withCtx(() => [
                        _createTextVNode("Eintrag gelöscht")
                      ]),
                      key: "2"
                    }
                  : (change.property == 'deleted' && change.to == false)
                    ? {
                        name: "custom",
                        fn: _withCtx(() => [
                          _createTextVNode("Eintrag wiederhergestellt")
                        ]),
                        key: "3"
                      }
                    : undefined
              ]), 1032, ["change-by", "change-text", "change-time"]))
            }), 128)),
            (history.value.length > 0)
              ? (_openBlock(), _createBlock(ChangelogEntry, {
                  key: 0,
                  "change-by": _unref(profileFromUid)(history.value[0].created_by) ?? null,
                  "change-time": _unref(shortLocaleString)(history.value[0].created_at),
                  "change-text": ""
                }, {
                  custom: _withCtx(() => [
                    _createTextVNode("Eintrag erstellt")
                  ]),
                  _: 1
                }, 8, ["change-by", "change-time"]))
              : _createCommentVNode("", true)
          ]))
    ]),
    _: 1
  }, 8, ["is-visible"]))
}
}

})